export default __webpack_public_path__ + "static/media/header-xs.5ff357e3.png";